export default HTTPClient => ({
  get: () => HTTPClient.get('config?show_hidden=true'),
});
